import {
  getResubscribePackagesList,
  resubscribePackage,
} from "../../../Redux/Resubscribe/ResubscribeActions";
import AdditionalAmenitiesModal from "../../../Components/User/AdditionalAmenitiesModal/AdditionalAmenitiesModal";
import AdditionalAddonsModal from "../../../Components/User/AdditionalAddonsModal/AdditionalAddonsModal";
import AddCardModal from "../../../Components/User/Profile/AddCardModal/AddCardModal";
import { ColDef, GetRowIdParams, ICellRendererParams } from "ag-grid-community";
import { ReactComponent as TickIcon } from "../../../Assets/Tick.svg";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { getProfile } from "../../../Redux/Profile/ProfileActions";
import Stepper from "../../../Components/Common/Stepper/Stepper";
import Loading from "../../../Components/Common/Loading/Loading";
import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import { AppDispatch, RootState } from "../../../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import generateUuid from "../../../Util/generateUuid";
import SignatureCanvas from "react-signature-canvas";
import toastHelper from "../../../Util/toastHelper";
import validator from "../../../Util/validator";
import { HiDotsVertical } from "react-icons/hi";
import styles from "./Resubscribe.module.scss";
import { Switch } from "react-animated-switch";
import { FaFilePdf } from "react-icons/fa6";
import { AgGridReact } from "ag-grid-react";
import { useNavigate } from "react-router";
import API from "../../../API/API";
import html2pdf from "html2pdf.js";
import axios from "axios";

interface FamilyMember {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  bookingAllowed: boolean;
}

type AddonSelection = {
  addonId: number;
  noofAddonUnits: number;
  notifyAddon: boolean;
};

const Step4 = ({
  resubscribePackagesListData,
  email,
  voucherCode,
  setVoucherCode,
  voucherSuccess,
  setVoucherSuccess,
  packageData,
  parkingIds,
  parkingList,
  addonSelections,
  selectedCard,
  setSelectedCard,
  setAddNewCardModalOpen,
  profileData,
  errors,
  setErrors,
}: {
  resubscribePackagesListData: any;
  email: string;
  voucherCode: string;
  setVoucherCode: React.Dispatch<React.SetStateAction<string>>;
  voucherSuccess: any;
  setVoucherSuccess: React.Dispatch<React.SetStateAction<any>>;
  selectedCard: string;
  setSelectedCard: React.Dispatch<React.SetStateAction<string>>;
  setAddNewCardModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  profileData: any;
  errors: {
    cardHolderName: string;
    cardNumber: string;
    expiry: string;
    cvv: string;
    voucherCode: string;
  };
  setErrors: React.Dispatch<
    React.SetStateAction<{
      cardHolderName: string;
      cardNumber: string;
      expiry: string;
      cvv: string;
      voucherCode: string;
      firstName: string;
      lastName: string;
      phoneNumber: string;
      email: string;
      password: string;
      confirmPassword: string;
    }>
  >;
  packageData: any;
  parkingIds: number[];
  parkingList: any[];
  addonSelections: AddonSelection[];
}) => {
  const applyVoucherHandler = async () => {
    if (voucherCode.trim() !== "") {
      setErrors((prev) => ({
        ...prev,
        voucherCode: "",
      }));

      try {
        const { data } = await axios({
          url: `${API.members.validateVoucher.url}?voucherCode=${voucherCode}&email=${email}&voucherType=1`,
          method: API.members.validateVoucher.method,
        });

        setVoucherSuccess(data);
      } catch (error: any) {
        if (error?.response?.data?.message) {
          setErrors((prev) => ({
            ...prev,
            voucherCode: error?.response?.data?.message ?? "",
          }));
        } else {
          setErrors((prev) => ({
            ...prev,
            voucherCode: "Something went wrong",
          }));
        }
      }
    } else {
      setErrors((prev) => ({
        ...prev,
        voucherCode: "Voucher code is required",
      }));
    }
  };

  const removeVoucherHandler = () => {
    setVoucherSuccess(null);
    setVoucherCode("");
  };

  const monthlySubtotalBeforeVoucher = useMemo(() => {
    const packageRate =
      packageData?.discountRate > 0
        ? Number(packageData?.totalRates ?? 0) -
          Number(packageData?.discountRate ?? 0)
        : Number(packageData?.totalRates ?? 0);

    const parkingTotal = (parkingList || []).reduce((acc: number, parking: any) => {
      const slotIds = (parking?.parkingdata ?? []).map(
        (slot: { ParkingId: number }) => slot.ParkingId,
      );
      const selectedCount = parkingIds.filter((id) =>
        slotIds.includes(id),
      ).length;
      return (
        acc + Number(parking?.rates ?? parking?.cost ?? 0) * selectedCount
      );
    }, 0);

    const addonTotal = addonSelections.reduce((acc, selection) => {
      const addon = resubscribePackagesListData?.addon?.find(
        (a: any) => a.addonId === selection.addonId,
      );

      return (
        acc + Number(addon?.cost ?? 0) * Number(selection.noofAddonUnits ?? 0)
      );
    }, 0);

    return packageRate + parkingTotal + addonTotal;
  }, [
    packageData,
    parkingIds,
    parkingList,
    addonSelections,
    resubscribePackagesListData,
  ]);

  const voucherDiscountAmount = useMemo(() => {
    if (!voucherSuccess?.success || !voucherSuccess?.voucher) return 0;

    const { percent, maxDiscount } = voucherSuccess.voucher;
    const percentValue = Number(percent ?? 0);

    let discount = (monthlySubtotalBeforeVoucher * percentValue) / 100;

    if (maxDiscount !== null && maxDiscount !== undefined) {
      discount = Math.min(discount, Number(maxDiscount));
    }

    return Number(discount.toFixed(2));
  }, [monthlySubtotalBeforeVoucher, voucherSuccess]);

  return (
    <div className={styles.stepFourContainer}>
      <div className={styles.stepFiveContentWrapper}>
        <div className={styles.packageInfoWrapper}>
          <div className={styles.packageInfoContainer}>
            <p className={styles.label}>Package Selected</p>

            <p className={styles.packageName}>
              {packageData?.packageName} - ${packageData?.totalRates}/mo
            </p>
          </div>

          {parkingIds.length > 0 && (
            <div className={styles.additionalAmenitiesContainer}>
              <p className={styles.label}>Additional Amenities</p>

              <div className={styles.amenitiesList}>
                {(parkingList || []).map((parking: any) => {
                  const slotIds = (parking?.parkingdata ?? []).map(
                    (slot: { ParkingId: number }) => slot.ParkingId,
                  );
                  const selectedCount = parkingIds.filter((id) =>
                    slotIds.includes(id),
                  ).length;

                  if (selectedCount === 0) return null;

                  return (
                    <div key={parking?.amenityId} className={styles.amenity}>
                      <p className={styles.label}>
                        {parking?.name ?? parking?.amenityName} - Parking
                      </p>

                      <p className={styles.price}>
                        $
                        {(parking?.rates ?? parking?.cost ?? 0) * selectedCount}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {addonSelections.some((s) => s.noofAddonUnits > 0) && (
            <div className={styles.additionalAmenitiesContainer}>
              <p className={styles.label}>Additional Addons</p>

              <div className={styles.amenitiesList}>
                {addonSelections.map((selection, i) => {
                  const addon = resubscribePackagesListData?.addon?.find(
                    (a: any) => a.addonId === selection.addonId,
                  );

                  if (!addon || selection.noofAddonUnits <= 0) return null;

                  return (
                    <div key={i} className={styles.amenity}>
                      <p className={styles.label}>
                        {addon?.amenityName} - Addon
                      </p>

                      <p className={styles.price}>
                        ${(addon?.cost ?? 0) * selection.noofAddonUnits}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {!voucherSuccess ? (
            <div className={styles.couponInputContainer}>
              <div className={styles.couponInputBox}>
                <input
                  className={styles.input}
                  type="text"
                  placeholder="Enter Voucher Code"
                  value={voucherCode}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\s/g, "");

                    setVoucherCode(value);
                  }}
                />

                <p className={styles.error}>{errors.voucherCode}</p>
              </div>

              <button className={styles.button} onClick={applyVoucherHandler}>
                Apply
              </button>
            </div>
          ) : (
            <div className={styles.couponSuccessContainer}>
              <p className={styles.heading}>Coupon Applied</p>

              <div className={styles.voucherContainer}>
                <p className={styles.voucherCode}>{voucherCode}</p>

                <p className={styles.voucherDiscount}>
                  ${voucherDiscountAmount}
                </p>
              </div>

              <div className={styles.buttonContainer}>
                <button
                  className={styles.button}
                  onClick={removeVoucherHandler}
                >
                  Remove Voucher
                </button>
              </div>
            </div>
          )}
        </div>

        <div className={styles.inputContainer}>
          <p className={styles.label}>Select Card</p>

          <select
            className={styles.input}
            value={selectedCard}
            onChange={(e) => setSelectedCard(e.target.value)}
          >
            {!selectedCard && <option value="">Select Card</option>}

            {profileData?.memberCCInfo?.map((card: any, i: number) => (
              <option key={i} value={card?.id}>
                XXX - {card?.cardNumber}
              </option>
            ))}
          </select>
        </div>

        <div className={styles.cardButtonContainer}>
          <button
            className={styles.button}
            onClick={() => setAddNewCardModalOpen(true)}
          >
            Add new card
          </button>
        </div>
      </div>
    </div>
  );
};

const Step2 = ({
  familyMembers,
  setFamilyMembers,
  packageData,
}: {
  familyMembers: FamilyMember[];
  setFamilyMembers: React.Dispatch<React.SetStateAction<FamilyMember[]>>;
  packageData: any;
}) => {
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");

  const [errors, setErrors] = useState<{
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
  }>({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
  });

  const addMemberHandler = () => {
    if (packageData?.noofMembers < familyMembers.length) {
      toastHelper.error(
        "You have reached the maximum number of family members",
      );

      return;
    }

    const { errors: fieldErrors, isValid } = validator([
      {
        key: "firstName",
        type: "text",
        value: firstName,
      },
      {
        key: "lastName",
        type: "text",
        value: lastName,
      },
      {
        key: "email",
        type: "email",
        value: email,
      },
      {
        key: "phoneNumber",
        type: "text",
        value: phoneNumber,
      },
    ]);

    setErrors((prev) => ({
      ...prev,
      ...fieldErrors,
    }));

    if (isValid) {
      const emailExists = familyMembers.some(
        (member) => member.email === email,
      );

      if (emailExists) {
        setErrors((prev) => ({
          ...prev,
          email: "Email already exists",
        }));

        return;
      }

      setFamilyMembers((prev) => [
        ...prev,
        {
          id: generateUuid(),
          firstName,
          lastName,
          email,
          phoneNumber,
          bookingAllowed: false,
        },
      ]);

      memberClearHandler();
    }
  };

  const deleteMemberHandler = (id: string) => {
    setFamilyMembers((prev) => prev.filter((member) => member.id !== id));
  };

  const memberClearHandler = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhoneNumber("");

    setErrors({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
    });
  };

  const columnDefs = useMemo<ColDef<FamilyMember>[]>(
    () => [
      {
        headerName: "First Name",
        field: "firstName",
        flex: 1,
      },
      {
        headerName: "Last Name",
        field: "lastName",
        flex: 1,
      },
      {
        headerName: "Email",
        field: "email",
        flex: 1,
      },
      {
        headerName: "Phone",
        field: "phoneNumber",
        flex: 1,
      },
      {
        headerName: "Booking Allowed",
        field: "bookingAllowed",
        flex: 1,

        cellRenderer: (params: ICellRendererParams<FamilyMember>) => (
          <Switch
            inActiveTrackColor="#DFDFDF"
            activeTrackColor="#C0F496"
            inActiveThumbColor="#000000"
            activeThumbColor="#000000"
            checked={params?.data?.bookingAllowed ?? false}
            onChange={(val) => {
              setFamilyMembers((prev) =>
                prev.map((member) =>
                  member.id === params?.data?.id
                    ? {
                        ...member,
                        bookingAllowed: val,
                      }
                    : member,
                ),
              );
            }}
          />
        ),
      },
      {
        sortable: false,
        suppressAutoSize: true,
        suppressMovable: true,
        suppressNavigable: true,
        width: 100,
        editable: false,

        cellStyle: {
          pointerEvents: "all",
          userSelect: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        },

        cellRenderer: (params: ICellRendererParams<FamilyMember>) => (
          <div className={styles.iconContainer}>
            <Menu
              direction="left"
              menuButton={
                <MenuButton>
                  <HiDotsVertical className={styles.icon} />
                </MenuButton>
              }
              transition
              portal
            >
              <MenuItem
                onClick={() => deleteMemberHandler(params?.data?.id ?? "")}
              >
                Delete
              </MenuItem>
            </Menu>
          </div>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setFamilyMembers],
  );

  const defaultColDef = useMemo<ColDef<FamilyMember>>(
    () => ({
      resizable: true,
      sortable: true,
      filter: false,
      wrapText: true,
      autoHeight: true,
      unSortIcon: true,
    }),
    [],
  );

  return (
    <div className={styles.stepTwoContainer}>
      <div className={styles.headingContainer}>
        <p className={styles.label}>Add Family Members</p>
      </div>

      <div className={styles.familyMembersContainer}>
        <div className={styles.gridContainer}>
          <AgGridReact
            className={styles.grid}
            rowData={familyMembers}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            getRowId={(params: GetRowIdParams<FamilyMember>) => params.data.id}
            animateRows
            domLayout="autoHeight"
          />
        </div>

        <div className={styles.formContainer}>
          <div className={styles.inputContainer}>
            <p className={styles.label}>First Name</p>

            <input
              className={styles.input}
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />

            <p className={styles.error}>{errors.firstName}</p>
          </div>

          <div className={styles.inputContainer}>
            <p className={styles.label}>Last Name</p>

            <input
              className={styles.input}
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />

            <p className={styles.error}>{errors.lastName}</p>
          </div>

          <div className={styles.inputContainer}>
            <p className={styles.label}>Email</p>

            <input
              className={styles.input}
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <p className={styles.error}>{errors.email}</p>
          </div>

          <div className={styles.inputContainer}>
            <p className={styles.label}>Phone Number</p>

            <input
              className={styles.input}
              type="text"
              value={phoneNumber}
              onChange={(e) => {
                const value = e.target.value;

                if (/^\d*$/.test(value)) {
                  setPhoneNumber(value);
                }
              }}
            />

            <p className={styles.error}>{errors.phoneNumber}</p>
          </div>

          <div className={styles.buttonsContainer}>
            <button className={styles.button} onClick={addMemberHandler}>
              Add Member
            </button>

            <button className={styles.clearButton} onClick={memberClearHandler}>
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

function Resubscribe() {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const signRef = useRef<SignatureCanvas>(null);

  const {
    resubscribePackagesListLoading,
    resubscribePackagesListData,
    resubscribePackageLoading,
  } = useSelector((state: RootState) => state.resubscribe);

  const { profileData, profileLoading } = useSelector(
    (state: RootState) => state.profile,
  );

  const [voucherCode, setVoucherCode] = useState<string>("");

  const [voucherSuccess, setVoucherSuccess] = useState<any>(null);

  const [currentStep, setCurrentStep] = useState<number>(0);

  const [selectedPackage, setSelectedPackage] = useState<number>(-1);

  const [addNewCardModalOpen, setAddNewCardModalOpen] = useState(false);

  const [signature, setSignature] = useState<string>("");

  const [familyMembers, setFamilyMembers] = useState<FamilyMember[]>([]);

  const [selectedCard, setSelectedCard] = useState<string>("");

  const [parkingIds, setParkingIds] = useState<number[]>([]);
  const [notifyParkingIds, setNotifyParkingIds] = useState<number[]>([]);

  const [addonSelections, setAddonSelections] = useState<AddonSelection[]>([]);

  const [additionalAmenitiesModal, setAdditionalAmenitiesModal] =
    useState(false);

  const [additionalAddonsModal, setAdditionalAddonsModal] = useState(false);

  const [errors, setErrors] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    cardHolderName: "",
    cardNumber: "",
    expiry: "",
    cvv: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    voucherCode: "",
  });

  const packageData: any = useMemo(() => {
    return resubscribePackagesListData?.packages?.find(
      (pack: any) => pack.packageId === selectedPackage,
    );
  }, [resubscribePackagesListData, selectedPackage]);

  const maxSteps = 4;

  const nextStepHandler = () => {
    let step = currentStep + 1;

    if (step === maxSteps) {
      if (!resubscribePackagesListLoading) {
        const successHandler = () => {
          navigate("/", {
            replace: true,
          });
        };

        dispatch(
          resubscribePackage({
            packageId: selectedPackage.toString(),
            signature: signature,
            memberCCInfoId: selectedCard.toString(),
            familyMember: packageData?.isFamily ? familyMembers : [],
            parkingIds,
            notifyParkingIds,
            addons: addonSelections.filter((s) => s.noofAddonUnits > 0),
            voucherCode: voucherSuccess?.voucher?.name,
            successHandler,
          }),
        );
      } else {
        toastHelper.error("Please wait for the signup to complete");
      }
    } else {
      if (currentStep === 0 && packageData?.isFamily) {
        setCurrentStep(step);

        return;
      } else if (currentStep === 0 && !packageData?.isFamily) {
        setCurrentStep(step + 1);
      } else {
        setCurrentStep(step);
      }
    }
  };

  const backStepHandler = () => {
    const step = currentStep - 1;

    if (step >= 0) {
      if (currentStep === 2 && packageData?.isFamily) {
        setCurrentStep(step);
      } else if (currentStep === 2 && !packageData?.isFamily) {
        setCurrentStep(step - 1);
      } else {
        setCurrentStep(step);
      }
    }
  };

  const stepHandler = () => {
    if (currentStep === 0) {
      if (selectedPackage !== -1) {
        nextStepHandler();
      } else {
        toastHelper.error("Please select a package");
      }
    }

    if (currentStep === 1) {
      if (familyMembers.length === 0) {
        toastHelper.error("Please add at least one member");

        return;
      }

      nextStepHandler();
    }

    if (currentStep === 2) {
      if (signRef?.current) {
        if (signRef.current.isEmpty()) {
          toastHelper.error("Please sign the agreement");
        } else {
          setSignature(signRef.current.toDataURL());

          nextStepHandler();
        }
      }
    }

    if (currentStep === 3) {
      if (selectedCard) {
        nextStepHandler();
      } else {
        toastHelper.error("Please select a card");

        return;
      }
    }
  };

  const Step1 = () => {
    return (
      <div className={styles.stepOneContainer}>
        <div className={styles.headingContainer}>
          <p className={styles.label}>Select package</p>
        </div>

        <div className={styles.additionalbuttonInline}>
          {resubscribePackagesListData?.parking?.length > 0 && (
            <div className={styles.additionalbuttonContainer}>
              <button onClick={() => setAdditionalAmenitiesModal(true)}>
                Select Additional Amenities
              </button>
            </div>
          )}

          {resubscribePackagesListData?.addon?.length > 0 && (
            <div className={styles.additionalbuttonContainer}>
              <button onClick={() => setAdditionalAddonsModal(true)}>
                Select Additional Addons
              </button>
            </div>
          )}
        </div>

        <div className={styles.packagesContainer}>
          {resubscribePackagesListData?.packages?.map(
            (pack: any, i: number) => {
              return (
                <div key={i} className={styles.package}>
                  <div className={styles.infoContainer}>
                    <p className={styles.name}>{pack?.packageName}</p>

                    <div className={styles.priceContainer}>
                      {pack?.discountRate > 0 ? (
                        <>
                          <p className={styles.price}>
                            ${pack?.totalRates - pack?.discountRate}
                            /mo
                          </p>

                          <p className={styles.cancelledPrice}>
                            ${pack?.totalRates}
                            /mo
                          </p>
                        </>
                      ) : (
                        <p className={styles.price}>
                          ${pack?.totalRates}
                          /mo
                        </p>
                      )}
                    </div>
                  </div>

                  <div className={styles.trialContainer}>
                    {pack?.isFreeMonth && (
                      <p className={styles.label}>
                        This package has a limited time free trial
                      </p>
                    )}
                  </div>

                  <div className={styles.buttonContainer}>
                    <button
                      className={styles.button}
                      onClick={() => setSelectedPackage(pack?.packageId)}
                    >
                      {selectedPackage === pack?.packageId
                        ? "Selected"
                        : "Select"}
                    </button>
                  </div>

                  <div className={styles.featuresContainer}>
                    <p>Plan includes</p>

                    {pack?.packageAmenities?.map((amenity: any, j: number) => {
                      return (
                        <div key={j} className={styles.feature}>
                          <div className={styles.iconContainer}>
                            <TickIcon className={styles.icon} />
                          </div>

                          <p className={styles.label}>{amenity}</p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            },
          )}
        </div>
      </div>
    );
  };

  const Step3 = ({ content }: { content: string }) => {
    const contentRef = useRef<HTMLDivElement>(null);

    const handleDownloadPDF = () => {
      const element = contentRef.current;

      const opt: any = {
        margin: 0.5,
        filename: "Amengies Terms and Conditions.pdf",
        image: {
          type: "jpeg",
          quality: 1,
        },
        html2canvas: { scale: 2 },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "portrait",
        },
      };

      if (element) {
        html2pdf().set(opt).from(element).save();
      }
    };

    return (
      <div className={styles.stepThreeContainer}>
        <div className={styles.pdfButtonContainer}>
          <button className={styles.button} onClick={handleDownloadPDF}>
            <FaFilePdf className={styles.icon} />
          </button>
        </div>

        <div
          className={styles.contentContainer}
          dangerouslySetInnerHTML={{
            __html: content,
          }}
          ref={contentRef}
        ></div>

        <div className={styles.signatureContainer}>
          <p className={styles.label}>Sign the agreement</p>

          <div className={styles.signature}>
            <SignatureCanvas
              penColor="black"
              ref={signRef}
              canvasProps={{
                className: `${styles.signatureCanvas}`,
              }}
            />
          </div>

          <div className={styles.buttonContainer}>
            <button
              className={styles.clearButton}
              onClick={() => {
                if (signRef.current) {
                  signRef.current.clear();
                }
              }}
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 0:
        return <Step1 />;

      case 1:
        return (
          <Step2
            familyMembers={familyMembers}
            setFamilyMembers={setFamilyMembers}
            packageData={packageData}
          />
        );

      case 2:
        return (
          <Step3 content={resubscribePackagesListData?.termsAndConditions} />
        );

      case 3:
        return (
          <Step4
            resubscribePackagesListData={resubscribePackagesListData}
            email={profileData?.member?.email}
            voucherCode={voucherCode}
            setVoucherCode={setVoucherCode}
            voucherSuccess={voucherSuccess}
            setVoucherSuccess={setVoucherSuccess}
            packageData={packageData}
            parkingIds={parkingIds}
            parkingList={resubscribePackagesListData?.parking || []}
            addonSelections={addonSelections}
            selectedCard={selectedCard}
            setSelectedCard={setSelectedCard}
            errors={errors}
            setErrors={setErrors}
            setAddNewCardModalOpen={setAddNewCardModalOpen}
            profileData={profileData}
          />
        );

      default:
        return <></>;
    }
  };

  useEffect(() => {
    dispatch(
      getProfile({
        navigate: navigate,
      }),
    );

    dispatch(getResubscribePackagesList());
  }, [dispatch, navigate]);

  if (resubscribePackagesListLoading || profileLoading) {
    return <Loading />;
  }

  return (
    <React.Fragment>
      <AddCardModal
        isOpen={addNewCardModalOpen}
        setIsOpen={setAddNewCardModalOpen}
      />

      <AdditionalAmenitiesModal
        isOpen={additionalAmenitiesModal}
        setIsOpen={setAdditionalAmenitiesModal}
        parkingIds={parkingIds}
        setParkingIds={setParkingIds}
        notifyParkingIds={notifyParkingIds}
        setNotifyParkingIds={setNotifyParkingIds}
        parkingOptions={resubscribePackagesListData?.parking || []}
      />

      <AdditionalAddonsModal
        isOpen={additionalAddonsModal}
        setIsOpen={setAdditionalAddonsModal}
        addonSelections={addonSelections}
        setAddonSelections={setAddonSelections}
        addonOptions={resubscribePackagesListData?.addon || []}
      />

      <div className={styles.mainContainer}>
        <div className={styles.stepContainer}>
          <Stepper
            showLabel={true}
            currentStep={currentStep}
            steps={Array.from({ length: maxSteps }, (_, index) => ({
              id: index + 1,
              label: `Step ${index + 1}`,
            }))}
          />
        </div>

        <div className={styles.bodyContainer}>{renderCurrentStep()}</div>

        {resubscribePackageLoading && <Loading />}

        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={stepHandler}>
            {currentStep === maxSteps - 1 ? "Resubscribe" : "Next"}
          </button>
        </div>

        {currentStep !== 0 && (
          <div className={styles.buttonContainer}>
            <button className={styles.back} onClick={backStepHandler}>
              Back
            </button>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default Resubscribe;
